export default __webpack_public_path__ + "static/media/14_MestMarzipan-Commercial-EschweilerPhotography_21A5908 Kopie.69db8014.jpg";